(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("_"), require("Next"), require("ReactDOM"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["React", "_", "Next", "ReactDOM", "moment"], factory);
	else if(typeof exports === 'object')
		exports["ReceptForm"] = factory(require("React"), require("_"), require("Next"), require("ReactDOM"), require("moment"));
	else
		root["ReceptForm"] = factory(root["React"], root["_"], root["Next"], root["ReactDOM"], root["moment"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__30__) {
return 